import { BaseEnum } from './baseEnum';

const listEnum: Array<TimeOccurrenceSubType> = [];

export class TimeOccurrenceSubType extends BaseEnum {
  static Unset = new TimeOccurrenceSubType(0, 'UNSET', 'Não informado', 'secondary');
  static Overtime = new TimeOccurrenceSubType(
    1,
    'OVERTIME',
    'Horas extras',
    'success'
  );
  static Absence = new TimeOccurrenceSubType(2, 'ABSENCE', 'Ausência', 'warning');

  constructor(
    public id: number,
    public value: string,
    public label: string,
    public className: string
  ) {
    super(id, value, label, className);
    listEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listEnum;
  }
}
